<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="making-friends">
<h1>5. Making Friends</h1>
<p>Jasmine let herself into her apartment, it had been a hectic day with that obnoxious Frobisher questioning every point during her presentation, still, she had been able to counter all his objections and criticisms, at times making him look more than a little ridiculous.</p>
<p>However, if she was going to have a permanent position in this organisation, whatever it was, he would be someone to watch out for. Glancing at the clock there was just time for a shower before dinner.</p>
<p>Dressed, she checked herself in the mirror, ’Must do some shopping this is the third successive night I have worn this dress', closing the door she walked the few yards to number two and pressed the bell. Clary was busy with a telephone call and told Jasmine to carry on to the restaurant and order and she would join her in five minutes.</p>
<p>This was the first time Jasmine had entered the restaurant on her own, at the bar, she ordered Clary's white wine, with an orange juice for herself and made her way to a table. Hardly having taken her seat, a smartly dressed man about her own age stopped next to her.</p>
<p>“Hello, I haven't seen you before?”</p>
<p>“Only been here a couple of days.”</p>
<p>“Where are you working?”</p>
<p>Remembering the ’job profile' she said, “Ag and Fish, they have me running errands at the moment to find my way about.”</p>
<p>“My name's Simon, and yours?”</p>
<p>“Jasmine,” and could have kicked herself on what he said next.</p>
<p>“You must be the one Frobisher is banging on about.”</p>
<p>“Oh really? What can I possibly have done to cause that sort of reaction?”</p>
<p>“Being intelligent. Our Mark Frobisher considers women inferior beings, good for one thing only.”</p>
<p>“Hmm! I'm not a feminist but I take exception to that!”</p>
<p>“Careful, he's powerful.”</p>
<p>“Thanks for the warning, now I see my friend is coming. If you will excuse me.”</p>
<p>“Sure, see you again, perhaps?”</p>
<p>“Maybe.”</p>
<p>“Sorry I took so long Jazz; I see you had company?” Clary said as she reached the table.</p>
<p>“Quite pleasant, gave me a bit of information.”</p>
<p>“His phone number?”</p>
<p>“Not quite, tell me the Official Secrets Act, does it apply within the departments?”</p>
<p>“I'll say it does, everywhere in fact, why?”</p>
<p>“Mr Frobisher doesn't seem to like intelligent women and is evidently sounding off to all and sundry about me and the presentation.”</p>
<p>“We'll have a word with Henry in the morning. now where's my drink?”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?64c145e4